/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isBlank, isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import TemplateModel from 'cio/models/template';
import { isCannotBeBlankError } from 'cio/utils/errors/blank';
import { InAppPreview } from 'cio/utils/previews';

interface RecipientSummaryArgs {
  template: TemplateModel;
  preview: InAppPreview;
  isPreviewLoading: boolean;
  showErrors: boolean;
}

export default class RecipientSummary extends Component<RecipientSummaryArgs> {
  get isRecipientConfigured() {
    return !isBlank(this.args.template.recipient);
  }

  get hasError() {
    return !this.isRecipientConfigured || this.hasLiquidError;
  }

  get hasLiquidError() {
    let recipientErrors = this.args.preview?.errors?.to ?? [];
    let liquidErrors = recipientErrors.filter((err) => !isCannotBeBlankError(err));
    return !isEmpty(liquidErrors);
  }

  get errorMessage() {
    if (this.hasLiquidError) {
      let [firstErrorMessage] = this.args.preview.errors.to!;
      return firstErrorMessage;
    }
    return '';
  }
}
